'use client'

import { ReactNode } from 'react'
import { PermissionGuard } from '@/components/partials'

type PropsType = {
  children: ReactNode
  permission: string
  action: string
}

/**
 * Generic Page Guard Component
 * Wraps page content with permission checking
 * Throws 403 error if permission is not granted
 *
 * @example
 * <PageGuard permission="SETTINGS" action="CONTENT_SHOW">
 *   <YourPageContent />
 * </PageGuard>
 */
const PageGuard = ({ children, permission, action }: PropsType) => {
  return (
    <PermissionGuard permission={permission} action={action}>
      {children}
    </PermissionGuard>
  )
}

export default PageGuard
